import { gql } from '@apollo/client'

export const CREATE_GROUP_COACHING_EVENT = gql`
  mutation CreateGroupCoachingEvent($input: GroupCoachingEventInput!) {
    createGroupCoachingEvent(input: $input) {
      id
      name
      userId
      createdAt
      updatedAt
      startsAt
      endsAt
      duration
      bookingUrl
      hideAttendees
      body
      googleCalendarId
      googleCalendarLink
      slug
      focusArea
      coachName
      coachEmail
      recordingLink
      activityType
      meetingBody
      meetingTitle
      videoConferenceUrl
      status
    }
  }
`
